'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import MyAccountForm from '@/Form/MyAccountForm'

export default PageWrapper(function UserPage (props)
{
	return (
		<Layout page_title="Mon compte" history={ props.history }>

			<div className="page-content">

				<HolidaysMessage />

				<div className="o-content">

					<MyAccountForm />

				</div>

			</div>

		</Layout>
	);
});